import type { SymbolKey } from '@/entities/symbol/types';

type SymbolComparableKey = keyof Pick<SymbolKey, 'Code' | 'Period' | 'PeriodType' | 'TimeRef'>;

function isSameByKeys(a: SymbolKey, b: SymbolKey, keys: readonly SymbolComparableKey[]): boolean {
  return keys.every(key => a[key] === b[key]);
}

export function isSameSymbol(a: SymbolKey, b: SymbolKey): boolean {
  return isSameByKeys(a, b, ['Code', 'Period', 'PeriodType', 'TimeRef']);
}

export function isSameSymbolIgnoringPeriod(a: SymbolKey, b: SymbolKey): boolean {
  return isSameByKeys(a, b, ['Code', 'PeriodType', 'TimeRef']);
}
